/*
  assets/mad-quote-lines.js (Worker C)
  Fills every door row on the cart page: plain summary from _raw, the per-door
  "Estimate before freight" from MADEstimate, Edit / Remove, "Price additional services" on
  door lines without _raw, and the footer totals. Exposes window.MadQuoteLines.collect() for
  the shared step (mad-quote-form.js, mad-quote-submit.js). Numbers come only from
  assets/mad-estimate.js and window.MAD_PRICE_BOOK; nothing is priced here.
  2026-09-25 (plan 5.4): doors priced with services live in the estimate list
  (assets/mad-estimate-list.js), rendered here as rows in [data-mad-estimate-list] with the same
  hooks as a cart row plus [data-mad-estimate-row]. While the list has doors, the estimate is the
  list (plus any older customized cart line); plain cart lines are purchases that check out normally.
  Release B (Seth 2026-10-12, one form): a plain door line's "Price additional services" ([data-mad-move-open]) opens
  the full form in mode 'cart-move' (assets/mad-wizard-cart.js moveToEstimate): the line leaves the cart, then every
  unit joins the estimate. The three quick questions (assets/mad-quote-quick.js) are retired; older saves they made
  still show "Details needed" and open with "Add details".
*/
(function () {
  'use strict';
  if (window.MadQuoteLines) return;

  var ROW = 'tr.cart-item[data-mad-line-key], [data-mad-estimate-row][data-mad-line-key]';
  var LINE_BOX = 'tr.cart-item[data-mad-line-key] [data-mad-quote-line], [data-mad-estimate-row] [data-mad-quote-line]';
  function EL() { var L = window.MadEstimateList; return L && L.enabled ? L : null; }
  function listActive() { var L = EL(); return !!(L && L.count() > 0); }
  /* Seth 2026-10-11: the customer picks these (no "Not sure", no "Review with Magnolia"); a door saved with one still
     open (the retired quick questions and sheet left the frame open; saves from before) says it is not chosen, flagged with Add details */
  var WALL = { '4_9_16': '4 9/16 in wall', '6_9_16': '6 9/16 in wall', other: 'custom wall depth', not_sure: 'wall thickness not chosen' };
  var SWING = { lhis: 'left hand inswing', lhos: 'left hand outswing', rhis: 'right hand inswing', rhos: 'right hand outswing',
    lhais: 'left active inswing', lhaos: 'left active outswing', rhais: 'right active inswing', rhaos: 'right active outswing', push: 'push swing', pull: 'pull swing', not_sure: 'swing not chosen' };
  var HINGE = { brushed_nickel: 'brushed nickel hinges', gold: 'brushed gold hinges', matte_black: 'matte black hinges', antique_bronze: 'antique bronze hinges', other: 'other hinge finish' };
  var APP = { sliding_barn: 'Sliding barn door', pocket_door: 'Pocket door', bifold: 'Bi-fold', decorative: 'Decorative, not hung' };
  var PAIR_OP = { both_active: 'Pair: both doors open', active_fixed: 'Pair: one active, one fixed', not_sure: 'Pair: opening not chosen yet' };
  /* an answer is picked only when it is one the wizard offers ("not_sure", "" and an old form's "undecided" are not) */
  function picked(map, v) { return !!v && v !== 'not_sure' && Object.prototype.hasOwnProperty.call(map, v); }
  var GRADE = { prime_pine: 1, stain_cypress: 1 };
  /* An Install Ready door with a frame answer still open: left for later by the retired quick questions (details_deferred
     yes), or a "Not sure" saved before 2026-10-11. Exterior jambs are always cypress, so the wood is never open there. */
  function frameOpen(raw) {
    if (!raw || raw.jamb_needed !== 'yes') return false;
    if (raw.details_deferred === 'yes') return true;
    return !picked(WALL, raw.wall_depth) || !picked(SWING, raw.swing) || !picked(HINGE, raw.hinge_color) || (raw.int_ext !== 'exterior' && !picked(GRADE, raw.jamb_grade));
  }
  /* A hinged pair whose opening (both doors, or one active and one fixed) is not chosen: the retired quick questions never asked
     it, and the wizard's "Not sure" (its default before 2026-10-11) is no answer now */
  function pairOpen(raw) {
    return !!raw && raw.door_config === 'pair' && (!raw.application || raw.application === 'standard_hinged') && raw.pair_operation !== 'both_active' && raw.pair_operation !== 'active_fixed';
  }
  /* Which step of the form Add details or Edit opens on (Release B, Seth 2026-10-12), by topic: the first open answer
     in the form's order (opening, workshop, hanging, review): the wax when it was never chosen (Workshop choices), how a
     pair opens, an old "price both" Install Ready or open frame details (How it hangs); "Review your door" when nothing
     is open (Edit); 0 when no choices could be read (the form starts fresh). The step comes from the topics each step
     declares (MadWizard.stepOf), with the same map here for a page where the form has not loaded. The form also asks
     any other open answer before it saves (mad-wizard-cart.js W.submit). */
  var TOPIC_STEP = { wax: 'workshop', pair: 'hanging', install: 'hanging', frame: 'hanging' };
  function openTopic(raw) {
    if (!raw) return null;
    if (raw.int_ext !== 'exterior' && !raw.wax_finish) return 'wax';
    if (pairOpen(raw)) return 'pair';
    if (raw.jamb_needed === 'not_sure') return 'install';
    return frameOpen(raw) ? 'frame' : null;
  }
  function openStep(raw) {
    if (!raw) return 0;
    var t = openTopic(raw), W = window.MadWizard;
    if (!t) return 'review';
    return (W && W.stepOf && W.stepOf(t)) || TOPIC_STEP[t];
  }

  function config() {
    var cq = {};
    var el = document.getElementById('mad-cq-config');
    try { cq = el ? JSON.parse(el.textContent) : {}; } catch (e) { cq = {}; }
    var base = window.MadQuoteConfig || {};
    /* MadQuoteConfig has phone/copy; mad-cq-config has script URLs. Merge so either snippet works. */
    return {
      phone: base.phone || cq.phone,
      priceBookSrc: base.priceBookSrc || cq.priceBookSrc,
      estimateSrc: base.estimateSrc || cq.estimateSrc
    };
  }

  function parseJSON(text) { try { return text ? JSON.parse(text) : null; } catch (e) { return null; } }

  function parseEmbedded(row, sel) {
    var el = row.querySelector(sel);
    if (!el) return null;
    try {
      var v = JSON.parse(el.textContent);
      if (typeof v === 'string') { try { return JSON.parse(v); } catch (e2) { return null; } }
      return v && typeof v === 'object' ? v : null;
    } catch (e) { return null; }
  }

  /* Load the maths and the price book ourselves when W's asset snippet is not on the page. */
  function ensureDeps() {
    return new Promise(function (resolve) {
      var settled = false;
      function done(ok) {
        if (settled) return;
        settled = true;
        resolve(!!ok);
      }
      function ready() { return !!(window.MADEstimate && window.MAD_PRICE_BOOK); }
      if (ready()) return done(true);
      var cfg = config();
      function inject(id, src) {
        if (!src) return;
        var existing = document.getElementById(id);
        if (existing) {
          existing.addEventListener('load', function () { if (ready()) done(true); });
          return;
        }
        var s = document.createElement('script');
        s.id = id; s.src = src;
        s.onload = function () { if (ready()) done(true); };
        s.onerror = function () { /* wait-loop decides failure */ };
        document.head.appendChild(s);
      }
      if (!window.MAD_PRICE_BOOK) inject('mad-price-book-js', cfg.priceBookSrc);
      if (!window.MADEstimate) inject('mad-estimate-js', cfg.estimateSrc);
      var tries = 0;
      (function wait() {
        if (ready()) return done(true);
        if (++tries > 200) return done(false);
        setTimeout(wait, 50);
      })();
    });
  }

  function productOf(row) {
    return parseEmbedded(row, '[data-mad-product-json]') || parseJSON(row.getAttribute('data-mad-product')) || {};
  }
  /* Saved choices are an object; anything else ('null', '[]', '123', a string) cannot be read as choices. */
  function plainObject(v) { return v && typeof v === 'object' && !Array.isArray(v) ? v : null; }
  function rawOf(row) {
    return plainObject(parseEmbedded(row, '[data-mad-raw-json]')) || plainObject(parseJSON(row.getAttribute('data-mad-raw')));
  }
  /* Codex re-check (2026-09-26), checkout safety: Liquid writes data-mad-raw and the embedded copy only for a line whose
     _raw is not blank, and then blocks checkout (sections/main-cart-footer.liquid). A row that carries them is a
     customized line whether or not its choices can be read here: it never unlocks checkout at the door-only price. */
  function rawSaved(row) { return row.hasAttribute('data-mad-raw') || !!row.querySelector('[data-mad-raw-json]'); }
  /* Codex re-check (R04): choices saved before the trusted-size fix are read with their computed advice recomputed from
     the size the page now gives this door (the row's product object), or sent to review (MADEstimate.normalizeSaved);
     quoteCart() sends the same. A save made since, and every choice the customer made, is unchanged. */
  function savedRaw(raw, product) {
    var E = window.MADEstimate, book = window.MAD_PRICE_BOOK;
    return raw && E && book && E.normalizeSaved ? E.normalizeSaved(raw, product, book).raw : raw;
  }

  /* One door line: raw, product, estimate, open items. */
  function lineOf(row) {
    var E = window.MADEstimate, book = window.MAD_PRICE_BOOK || {};
    var product = productOf(row), raw = savedRaw(rawOf(row), product);
    var qty = parseInt(row.getAttribute('data-mad-quantity'), 10) || 1;
    var line = {
      key: row.getAttribute('data-mad-line-key'), product: product, raw: raw, qty: qty, row: row, listRow: row.hasAttribute('data-mad-estimate-row'),
      title: product.title || '', code: (E && E.doorLabel) ? E.doorLabel(product.title) : (product.title || ''),
      isDoor: row.getAttribute('data-mad-door') === 'true',
      kind: row.getAttribute('data-mad-kind') || 'antique',
      doorPrice: (parseInt(row.getAttribute('data-mad-line-price'), 10) || 0) / 100,
      estimate: null, total: 0, services: 0,
      hasRawAttr: rawSaved(row),
    };
    /* a cart line whose saved choices cannot be read: checkout stays off, the row offers Price services again or Remove */
    line.rawUnreadable = !line.listRow && line.hasRawAttr && !raw;
    if (!raw || !E) { line.total = line.doorPrice; return line; }
    try {
      var tags = product.tags || [];
      var ctx = { doorPrice: (Number(product.price) || 0) / 100, config: raw.door_config || E.doorConfig(tags), flags: E.doorFlags(tags), kind: raw.door_kind || E.detectDoorKind(product) };
      line.ctx = ctx;
      line.estimate = E.estimate(raw, ctx, book);
      line.services = E.round2(line.estimate.services * qty);
      line.total = E.round2(line.estimate.total * qty);
      line.fitState = raw.fit_readout || (raw.not_measured === '1' || raw.opening_type === 'none' ? 'unmeasured' : '');
      line.notMeasured = line.fitState === 'unmeasured';
      line.deferred = raw.jamb_needed === 'yes' && raw.details_deferred === 'yes';
      /* Interior wax was never chosen (quick path deletes the key). Explicit "none" from the wizard is fine. */
      line.waxMissing = raw.int_ext !== 'exterior' && !raw.wax_finish;
      /* Seth 2026-10-11: "Review with Magnolia" is gone (QA Q-10 once counted it a complete answer). A door whose frame
         or pair answer is still open is flagged like a missing wax: Details needed, and Edit reads Add details. */
      line.frameOpen = frameOpen(raw);
      /* how a pair opens counts once the door is Install Ready (its frame and hardware), or when it was a "Not sure" */
      line.pairOpen = pairOpen(raw) && (raw.jamb_needed === 'yes' || raw.pair_operation === 'not_sure');
      line.needsDetails = !!line.waxMissing || line.frameOpen || line.pairOpen || raw.jamb_needed === 'not_sure';
      line.hasServices = line.estimate.services > 0;
    } catch (err) {
      line.estimate = null;
      line.total = line.doorPrice;
    }
    return line;
  }

  /* Plain bullets for collect(); structured items for the cart row UI. */
  function summaryItems(line) {
    var E = window.MADEstimate, book = window.MAD_PRICE_BOOK || {}, raw = line.raw, p = line.product, out = [];
    /* none: an item that only says nothing was chosen ("Door only", "No restoration", "No wax finish"). The cart row
       leaves it out (Seth 2026-10-12: "some things are a little self-explanatory"); summaryFor, what the request
       sends, keeps it. */
    function item(text, flag, none) { out.push({ text: text, flag: flag || '', none: !!none }); }
    /* R04: the size the product page shows (the object's size), or "Size to be confirmed"; never a size an older
       save took from the title */
    var ts = E.trustedSlab ? E.trustedSlab(p) : null;
    item(ts ? 'Slab ' + E.formatSlab(ts) : E.SIZE_TO_CONFIRM);
    if (line.notMeasured) item('Not measured yet');
    else if (raw.opening_type === 'finished') item('Finished opening ' + (raw.finished_opening || (raw.opening_width + ' x ' + raw.opening_height)));
    else if (raw.opening_type === 'rough') item('Rough opening ' + (raw.rough_opening || (raw.opening_width + ' x ' + raw.opening_height)));
    var place = raw.int_ext === 'exterior' ? 'Exterior' : 'Interior';
    if (raw.application && raw.application !== 'standard_hinged') place += ', ' + (APP[raw.application] || raw.application).toLowerCase();
    item(place);
    /* Seth 2026-10-13: how a pair opens follows Interior or Exterior, so the row leaves it out; the request keeps it */
    if (raw.pair_operation === 'both_active' || raw.pair_operation === 'active_fixed') item(PAIR_OP[raw.pair_operation], '', true);
    else if (line.pairOpen) item(PAIR_OP.not_sure, 'Details needed');
    if (raw.resize === 'yes') item('Resize to your opening' + (raw.target_width ? ' (' + raw.target_width + ' x ' + raw.target_height + ' in)' : ''));
    if (raw.jamb_needed === 'yes') {
      if (line.deferred) item('Install Ready, frame details not chosen yet', 'Details needed');
      else {
        var d = [WALL[raw.wall_depth] || WALL.not_sure, SWING[raw.swing] || SWING.not_sure, HINGE[raw.hinge_color] || 'hinges not chosen'];
        if (raw.int_ext !== 'exterior' && !picked(GRADE, raw.jamb_grade)) d.push('jamb wood not chosen');
        item('Install Ready: ' + d.join(', '), line.frameOpen ? 'Details needed' : '');
      }
    } else if (raw.jamb_needed === 'not_sure') item('Door only, Install Ready priced both ways', 'Details needed');
    else item('Door only', '', true);
    if ((raw.door_kind || (line.ctx && line.ctx.kind) || line.kind) === 'antique') {
      var tier = String(E.tierFromRaw(raw, book) || 'none'), tiers = book.restoration_tiers || {};
      var tierLabel = (tiers[tier] && tiers[tier].label) ? String(tiers[tier].label) : tier;
      /* the form's name for the tier (MADEstimate.CHOICE_NAMES, Release B): display only; Eric's lines are unchanged */
      var tierName = E.CHOICE_NAMES && E.CHOICE_NAMES.restore_tier && E.CHOICE_NAMES.restore_tier[tier];
      if (tier === 'none') item('No restoration', '', true);
      else item(tierName ? 'Restoration: ' + tierName : 'Restoration, ' + tierLabel.split(':')[0]);
    }
    if (raw.int_ext !== 'exterior') {
      if (line.waxMissing) item('Wax finish not chosen', 'Details needed');
      else if (raw.wax_finish && raw.wax_finish !== 'none') item('Wax finish, ' + (E.WAX_LABELS[raw.wax_finish] || raw.wax_finish));
      else item('No wax finish', '', true);
    }
    if (raw.glass_work && raw.glass_work !== 'none') {
      var gtxt = 'Glass: ' + ((E.GLASS_SHORT && E.GLASS_SHORT[raw.glass_work]) || E.GLASS_LABELS[raw.glass_work] || raw.glass_work);
      if (raw.glass_panes === 'not_sure') gtxt += ', pane sizes on the call';
      else if (raw.glass_panes) gtxt += ', ' + raw.glass_panes + (raw.glass_panes === '1' ? ' pane ' : ' panes ') + raw.glass_pane_width + ' x ' + raw.glass_pane_height + ' in';
      else if (E.glassOnCall && E.glassOnCall(raw, book)) gtxt += ', priced on your quote'; /* Seth, 2026-09-25 (answer 8) */
      item(gtxt);
    }
    if (raw.room_tag) item('Tag: ' + raw.room_tag);
    return out;
  }

  function summaryFor(line) {
    return summaryItems(line).map(function (it) { return it.text; });
  }

  function fillRow(row, line) {
    var box = row.querySelector('[data-mad-quote-line]');
    if (!box) return;
    var ul = box.querySelector('[data-mad-line-summary]');
    if (!ul) return;
    /* Still waiting on estimate maths: leave the Loading placeholder and retry. */
    if (line.raw && !window.MADEstimate) return;
    if (box.getAttribute('data-mad-filled') === '1') return;
    var E = window.MADEstimate;
    var items = [];
    try {
      if (line.raw && E) items = summaryItems(line).filter(function (it) { return !it.none; });
    } catch (err) { items = []; }
    if (!items.length) {
      if (line.hasRawAttr && !line.raw) {
        items = [{ text: 'We could not read the choices saved for this door.', flag: '' }];
      } else if (line.raw) {
        items = [{ text: 'Tap Edit to review your choices.', flag: '' }];
      } else {
        return;
      }
    }
    box.setAttribute('data-mad-filled', '1');
    box.classList.toggle('mad-ql--needs-details', !!line.needsDetails);
    ul.innerHTML = items.map(function (it) {
      var flag = it.flag
        ? ' <span class="mad-ql__flag" title="Choose this with Add details">' + esc(it.flag) + '</span>'
        : '';
      return '<li' + (it.flag ? ' class="mad-ql__item--alert"' : '') + '>' + esc(it.text) + flag + '</li>';
    }).join('');
    var callNote = box.querySelector('[data-mad-line-call-note]');
    if (callNote && line.rawUnreadable) {
      callNote.hidden = false;
      callNote.textContent = 'Price services again and request your quote, or remove this door to check out.';
    } else if (callNote) {
      /* Seth 2026-10-12: no row notes ("Use Add details to finish this door.", "You can add the size later."): the
         Details needed flag and the Add details button say it. Only a broken save keeps its note, above. */
      callNote.hidden = true;
      callNote.textContent = '';
    }
    var edit = box.querySelector('[data-mad-edit]');
    if (edit) {
      /* an unreadable line: Edit opens the wizard with fresh choices (cart-edit, no raw), which saves readable ones */
      var editWord = line.rawUnreadable ? 'Price services again' : line.needsDetails ? 'Add details' : 'Edit';
      edit.textContent = editWord;
      edit.setAttribute('aria-label', editWord + (line.rawUnreadable || line.needsDetails ? ' for ' : ' ') + (line.code || 'this door'));
    }
    var est = box.querySelector('[data-mad-line-estimate]');
    if (est && E && line.estimate) est.textContent = E.money(line.total);
    var fit = box.querySelector('[data-mad-line-fit]');
    if (fit && E) {
      /* Seth 2026-10-12: an unmeasured door already reads "Not measured yet" in its list; no second line */
      var text = line.fitState && line.fitState !== 'unmeasured' && E.FIT_TEXT[line.fitState];
      /* R04: a door with no trusted size was sent to review, not judged: say why */
      if (line.fitState === 'talk' && E.trustedSlab && !E.trustedSlab(line.product)) text = E.SIZE_TO_CONFIRM_TEXT;
      fit.hidden = !text;
      if (text) { fit.textContent = text; fit.setAttribute('data-state', line.fitState); }
    }
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* A logged-in customer with the Shopify tag "trade" (Liquid marks the page with [data-mad-trade-known]). */
  function tradeKnown() { return !!document.querySelector('[data-mad-trade-known]'); }

  /* Every line on the page, plus the totals the shared step needs. total is what the customer sees:
     for a known trade account it is after 10% off the door lines (D6); services and freight full price.
     Launch gate: the discount is taken off only while MAD_PRICE_BOOK.zap_supports.trade_discount is
     true (the Zap applies it on the draft); before that tradeApplied is false and the page says the
     trade pricing is confirmed on the quote, with no discounted total. Trade model of 2026-09-25
     (answer 7): the first paid order on the account earns store credit and gets no discount, so the flag
     must not be switched on until this function knows which order is the first (QUOTE and ZAP). */
  function collect() {
    var E = window.MADEstimate;
    var rows = Array.prototype.slice.call(document.querySelectorAll(ROW));
    var all = rows.map(lineOf);
    /* With the estimate list in use, the estimate is the quoted lines only; plain cart lines are purchases. */
    var inList = listActive();
    /* an older cart line whose choices cannot be read goes with the quote as a door to price on the call (quoteCart()
       sends it, so the total and the payload agree) */
    var lines = inList ? all.filter(function (l) { return !!l.raw || l.rawUnreadable; }) : all;
    /* Every door counts ("Alternative to" was removed on 2026-10-12, Seth: "it just over complicates things"). */
    var doors = 0, services = 0, total = 0, doorUnits = 0, doorLines = 0;
    lines.forEach(function (l) {
      doors += l.doorPrice; services += l.services; total += l.total;
      if (l.isDoor) { doorLines += l.doorPrice; doorUnits += l.qty; }
    });
    var r2 = E ? E.round2 : function (n) { return Math.round(n * 100) / 100; };
    var quoted = lines.filter(function (l) { return !!l.raw; });
    var trade = tradeKnown(), book = window.MAD_PRICE_BOOK || {};
    var tradeApplied = !!(trade && E && E.zapSupports && E.zapSupports(book, 'trade_discount'));
    var tradeDiscount = tradeApplied && E.tradeDiscount ? E.tradeDiscount(doorLines, book) : 0;
    return {
      lines: lines, quoted: quoted, doors: r2(doors), services: r2(services), subtotal: r2(total), total: r2(total - tradeDiscount),
      tradeKnown: trade, tradeApplied: tradeApplied, tradeDiscount: r2(tradeDiscount), doorCount: doorUnits, allLines: all, listActive: inList,
      /* exactly Liquid's rule: any cart line with a saved _raw, readable or not */
      cartRaw: all.some(function (l) { return !l.listRow && (!!l.raw || l.hasRawAttr); }),
      unreadable: all.filter(function (l) { return l.rawUnreadable; }),
      anyRaw: quoted.length > 0,
      anyService: quoted.some(function (l) { return l.hasServices; }),
      anyDeferred: quoted.some(function (l) { return l.deferred; }),
      anyUnmeasured: quoted.some(function (l) { return l.notMeasured; }),
      /* "one of one" is said of antiques only (Seth, 2026-09-26): the quote request shows it only when this is true */
      anyAntique: lines.some(function (l) { return l.isDoor && ((l.raw && l.raw.door_kind) || l.kind) === 'antique'; }),
      unpricedDoors: lines.filter(function (l) { return l.isDoor && !l.raw && (!inList || l.rawUnreadable); }),
      plainCartDoors: all.filter(function (l) { return l.isDoor && !l.raw && !l.listRow && !l.rawUnreadable; }).length,
      priceBookVersion: (window.MAD_PRICE_BOOK && window.MAD_PRICE_BOOK.version) || '',
    };
  }

  /* Money as assets/mad-estimate.js prints it ("$1,650", "$1,650.50"), also for a list drawn before that script has
     loaded (polish, 2026-09-26: the fallback printed "Door $1650.00"). */
  function money(n) {
    if (window.MADEstimate) return window.MADEstimate.money(n);
    n = Number(n);
    if (!isFinite(n)) return '';
    var abs = Math.abs(n), cents = Math.abs(abs - Math.round(abs)) > 0.004;
    var parts = (cents ? abs.toFixed(2) : String(Math.round(abs))).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (n < 0 ? '-' : '') + '$' + parts.join('.');
  }

  /* Seth 2026-10-13, a test: no prices in the estimate unless Theme settings > Quote funnel > Show prices is ticked
     (window.MadQuoteConfig.showPrices, snippets/mad-quote-assets.liquid); the maths and what is sent are unchanged */
  function showPrices() { return (window.MadQuoteConfig || {}).showPrices === true; }

  function fillTotals(c) {
    /* only write when the text changes, so the MutationObserver below does not loop; every copy
       (the estimate list block and the footer) gets the same numbers */
    var setAll = function (sel, text) { document.querySelectorAll(sel).forEach(function (el) { if (el.textContent !== text) el.textContent = text; }); };
    [['[data-mad-total-doors]', c.doors], ['[data-mad-total-services]', c.services], ['[data-mad-quote-total]', c.total]].forEach(function (pair) {
      setAll(pair[0], money(pair[1]));
    });
    /* trade account: the amount off once the Zap applies it, otherwise the sentence (answer 7: the first
       order earns store credit instead, so the page never promises a discount here) */
    setAll('[data-mad-total-trade]', c.tradeDiscount > 0 ? money(-c.tradeDiscount) : 'confirmed on your quote');
    document.querySelectorAll('[data-mad-trade-row]').forEach(function (row) { var hide = !c.tradeKnown; if (row.hidden !== hide) row.hidden = hide; });
    /* D8: freight range, count-aware (3 or more doors are quoted for the ZIP). Seth 2026-10-13: doors with services
       ship by Curbside LTL Freight, said by name, with no range while prices are hidden */
    var E = window.MADEstimate;
    if (E && E.deliveryText) setAll('[data-mad-freight-note]', E.deliveryText({ services: !!c.anyService, prices: showPrices(), doorCount: c.doorCount }, window.MAD_PRICE_BOOK || {}));
  }

  /* ── the estimate list block (plan 5.4) ─────────────────────────── */
  function attr(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  /* The row names the door by its short name, the same as its card, page and slide-out cart (p.name, from
     snippets/mad-card-name.liquid; polish, 2026-09-26: the row read "Antique 3 Panel Solid Single Door -
     32.5x87.5 - N537"), and keeps its stock code in front of the door price ("N537 · Door $1,650"), since many
     doors share a name. A line saved without a name shows the title, as before. Display only: the title, the
     _raw and the properties the Zap reads are unchanged. */
  function rowHtml(l) {
    var p = l.product || {}, E = window.MADEstimate, code = E ? E.doorLabel(p.title) : p.title;
    var name = p.name || p.title || code, shownCode = E && p.name && code !== p.title && name.indexOf(code) === -1 ? code : '';
    var kind = E ? E.detectDoorKind(p) : 'antique';
    var edit = (p.url || '#') + (String(p.url || '').indexOf('?') === -1 ? '?' : '&') + 'customize=1&variant=' + p.variantId;
    return '<div class="mad-el__row" data-mad-estimate-row data-mad-line-key="' + attr(l.id) + '" data-mad-product="' + attr(JSON.stringify(p)) + '" data-mad-raw="' + attr(JSON.stringify(l.raw || {})) + '"' +
      ' data-mad-kind="' + attr(kind) + '" data-mad-door="true" data-mad-price="' + attr(p.price) + '" data-mad-line-price="' + attr(p.price) + '" data-mad-quantity="1"' + (p.available === false ? ' data-mad-sold' : '') + '>' +
      (p.image ? '<img class="mad-el__img" src="' + attr(p.image) + '" alt="" width="72" height="72" loading="lazy">' : '<span class="mad-el__img" aria-hidden="true"></span>') +
      '<div class="mad-el__body"><a class="mad-el__name" href="' + attr(p.url || '#') + '">' + esc(name) + '</a>' +
      '<p class="mad-el__door">' + [shownCode ? esc(shownCode) : '', showPrices() ? 'Door ' + esc(money((Number(p.price) || 0) / 100)) : ''].filter(Boolean).join(' \u00b7 ') + (p.available === false ? ' <span class="mad-tag mad-tag--alert">Just sold</span>' : '') + '</p>' +
      '<div class="mad-ql" data-mad-quote-line data-mad-line-key="' + attr(l.id) + '" data-mad-has-raw="true" data-mad-is-door="true">' +
      '<ul class="mad-ql__summary list-unstyled" data-mad-line-summary aria-label="Your choices for ' + attr(code) + '"><li>Loading your choices</li></ul>' +
      (showPrices() ? '<p class="mad-ql__estimate"><span class="mad-ql__estimate-label">Estimate before freight</span> <strong class="mad-ql__estimate-value" data-mad-line-estimate></strong></p>' : '') +
      '<p class="mad-ql__fit" data-mad-line-fit hidden></p><p class="mad-ql__call-note" data-mad-line-call-note hidden></p>' +
      '<div class="mad-ql__actions"><a class="mad-ql__btn" href="' + attr(edit) + '" data-mad-edit data-mad-line-key="' + attr(l.id) + '" aria-label="Edit ' + attr(code) + '">Edit</a>' +
      '<button type="button" class="mad-ql__btn mad-ql__btn--quiet" data-mad-remove data-mad-line-key="' + attr(l.id) + '" aria-label="Remove ' + attr(code) + '">Remove</button></div>' +
      '</div></div></div>';
  }
  function renderList() {
    var L = EL(), active = listActive();
    document.documentElement.classList.toggle('mad-has-estimate', active);
    var box = document.querySelector('[data-mad-estimate-list]');
    if (!box || !L) return;
    box.hidden = !active;
    var rowsEl = box.querySelector('[data-mad-estimate-rows]');
    var list = L.lines();
    /* the maths loaded or not is part of the signature: a list drawn before assets/mad-estimate.js arrived is drawn
       again once it has, so the code, the kind and the labels that need it appear */
    var sig = (window.MADEstimate ? 'E' : '-') + JSON.stringify(list.map(function (l) { return [l.id, l.updatedAt, l.product && l.product.price, l.product && l.product.available]; }));
    if (rowsEl && rowsEl.getAttribute('data-sig') !== sig) {
      rowsEl.innerHTML = list.map(function (l) { return rowHtml(l); }).join('');
      rowsEl.setAttribute('data-sig', sig);
    }
    /* R03: what this browser keeps (a tab-only list, or none), said in the list's own words */
    var warn = box.querySelector('[data-mad-estimate-storage]');
    if (warn) { var limit = L.limitText ? L.limitText('cart') : ''; if (limit && warn.textContent !== limit) warn.textContent = limit; warn.hidden = L.persistent(); }
    var meta = L.meta(), sent = box.querySelector('[data-mad-estimate-sent]');
    if (sent) {
      sent.hidden = !meta.sentAt;
      if (meta.sentAt) sent.textContent = 'You sent this estimate on ' + new Date(meta.sentAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric' }) + '. Change it and send it again, or clear it.';
    }
    var soldList = list.filter(function (l) { return l.product && l.product.available === false; });
    var sold = box.querySelector('[data-mad-estimate-sold]');
    if (sold) {
      sold.hidden = !soldList.length;
      var phone = (window.MadQuoteConfig && window.MadQuoteConfig.phone) || '(337) 273-0189';
      if (soldList.length) sold.textContent = soldList.map(function (l) { return window.MADEstimate ? window.MADEstimate.doorLabel(l.product.title) : l.product.title; }).join(', ') + (soldList.length === 1 ? ' just sold. Remove it to send the rest, or call ' : ' just sold. Remove them to send the rest, or call ') + phone + ' and we will find a close match.';
    }
  }

  /* Checkout stays disabled while any CART line carries _raw (also after a quick save without a reload).
     Doors on the estimate list are not in the cart, so they never block checking out the cart. */
  function syncCheckout(c) {
    /* QA Q-03: "Your cart" while the cart holds something to pay for (a line that is neither an estimate-list
       row nor a customized _raw line); "Your estimate" while a cart line carries _raw, or while only the estimate
       list holds doors (the usual page after Review estimate from the form). A payable cart is
       never called a quote (redesign of 2026-09-26: estimate, quote request and paid order). */
    var payable = c.allLines.some(function (l) { return !l.listRow && !l.raw && !l.rawUnreadable; });
    var title = document.querySelector('[data-mad-cart-title]'), want = (c.cartRaw || (c.listActive && !payable)) ? 'Your estimate' : 'Your cart';
    if (title && title.textContent !== want) title.textContent = want;
    /* the estimate list's own "Your estimate" heading would repeat the page heading: kept for screen readers only */
    var elTitle = document.getElementById('mad-el-title');
    if (elTitle && elTitle.classList && elTitle.classList.contains('visually-hidden') !== (want === 'Your estimate')) elTitle.classList.toggle('visually-hidden', want === 'Your estimate');
    /* One filled button per view: beside doors bought as shown (Check out is live), the estimate list's
       Request your quote is outlined; with only the estimate, or a customized cart line (Check out is off), it stays filled. */
    var outline = !!(c.listActive && payable && !c.cartRaw);
    document.querySelectorAll('[data-mad-estimate-list] [data-mad-cq-open]').forEach(function (b) {
      if (b.classList.contains('button--secondary') !== outline) b.classList.toggle('button--secondary', outline);
    });
    var btn = document.getElementById('checkout'), footer = document.getElementById('main-cart-footer');
    if (!btn || !footer) return;
    var note = document.querySelector('[data-mad-estimate-cartnote]'); if (note) note.hidden = !(c.listActive && c.plainCartDoors > 0);
    /* Codex final review R02 (2026-09-26): Check out, the express checkout buttons and the sentence under them follow
       the cart both ways, after every change: an older customized line removed, a quantity changed, a line moved to
       the estimate, a partial re-render. They sit in the footer's buttons block, which neither Craft's cart.js nor
       refreshSections() re-renders (only the .js-contents parts), so the state Liquid drew on page load is never
       left standing: a cart that holds only doors bought as shown can always check out, without a reload. */
    var cartLines = c.allLines.filter(function (l) { return !l.listRow; });
    var empty = cartLines.length === 0, quoted = !!c.cartRaw, off = quoted || empty;
    if (btn.disabled !== off) btn.disabled = off;
    if (quoted) { if (btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true'); } else if (btn.hasAttribute('aria-disabled')) btn.removeAttribute('aria-disabled');
    if (footer.classList.contains('mad-cart--quoted') !== quoted) footer.classList.toggle('mad-cart--quoted', quoted);
    if (footer.classList.contains('is-empty') !== empty) footer.classList.toggle('is-empty', empty); /* as Liquid's cart == empty */
    if (footer.getAttribute('data-mad-has-raw') !== String(quoted)) footer.setAttribute('data-mad-has-raw', String(quoted));
    var dyn = document.getElementById('dynamic-checkout-wrapper');
    if (dyn && dyn.classList.contains('cart__dynamic-checkout--hidden') !== quoted) dyn.classList.toggle('cart__dynamic-checkout--hidden', quoted);
    var blockedMsg = document.getElementById('checkout-blocked-msg'), why = blockedText(c);
    if (quoted && !blockedMsg) {
      var p = document.createElement('p'); p.id = 'checkout-blocked-msg'; p.className = 'cart__checkout-blocked-msg mad-checkout-blocked';
      p.setAttribute('data-mad-checkout-blocked', ''); p.textContent = why;
      btn.parentNode.insertBefore(p, btn.nextSibling);
    } else if (quoted && String(blockedMsg.textContent || '').trim() !== why) blockedMsg.textContent = why;
    else if (!quoted && blockedMsg && blockedMsg.parentNode) blockedMsg.parentNode.removeChild(blockedMsg);
  }
  /* The sentence under the disabled Check out: why, and the way out when a line's saved choices cannot be read */
  function blockedText(c) {
    var bad = c.unreadable || [];
    if (!bad.length) return 'Doors with shop work are priced by estimate. Request your quote below.';
    var codes = bad.map(function (l) { return l.code || 'a door'; }).join(' and ');
    return 'We could not read the choices saved for ' + codes + '. Price services again and request your quote, or remove ' + (bad.length > 1 ? 'them' : 'it') + ' to check out.';
  }

  var refreshing = false;
  var retryTimer = null;
  var refreshAttempts = 0;
  function refresh() {
    if (refreshing) return; refreshing = true;
    ensureDeps().then(function (ok) {
      refreshing = false;
      renderList();
      var c = collect();
      c.allLines.forEach(function (l) { if (l.row) fillRow(l.row, l); });
      fillTotals(c); syncCheckout(c);
      document.dispatchEvent(new CustomEvent('mad:quote:updated', { detail: c }));
      var stillLoading = false;
      document.querySelectorAll(LINE_BOX).forEach(function (box) {
        if (box.getAttribute('data-mad-filled') === '1') return;
        if (box.querySelector('[data-mad-line-summary]')) stillLoading = true;
      });
      if (stillLoading && refreshAttempts < 50) {
        refreshAttempts += 1;
        clearTimeout(retryTimer);
        retryTimer = setTimeout(refresh, 300);
      } else if (stillLoading) {
        document.querySelectorAll(LINE_BOX).forEach(function (box) {
          if (box.getAttribute('data-mad-filled') === '1') return;
          var ul = box.querySelector('[data-mad-line-summary]');
          if (!ul) return;
          box.setAttribute('data-mad-filled', '1');
          ul.innerHTML = '<li>Tap Edit to review your choices.</li>';
        });
      } else {
        refreshAttempts = 0;
      }
    }).catch(function () {
      refreshing = false;
      if (refreshAttempts < 50) {
        refreshAttempts += 1;
        clearTimeout(retryTimer);
        retryTimer = setTimeout(refresh, 800);
      }
    });
  }

  /* Re-render both cart sections after MadWizard changed a line (Craft may do it too; harmless). */
  function refreshSections() {
    return fetch('/cart?sections=main-cart-items,main-cart-footer', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (data) {
      ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
        var html = data[id]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var from = doc.querySelector('.js-contents'), to = document.querySelector('#' + id + ' .js-contents');
        if (from && to) to.innerHTML = from.innerHTML;
        if (id === 'main-cart-items') {
          var wrapFrom = doc.querySelector('cart-items'), wrapTo = document.querySelector('cart-items');
          if (wrapFrom && wrapTo) wrapTo.classList.toggle('is-empty', wrapFrom.classList.contains('is-empty'));
        }
      });
      /* the cart's last plain line moved to the estimate: the rows are drawn again here, so they are filled too
         (they stayed on "Loading your choices" until a reload; audit of 2026-10-13) */
      if (!document.querySelector(ROW)) { renderList(); if (!document.querySelector(ROW) && !keepPage()) window.location.reload(); else schedule(); }
      else schedule();
    }).catch(function () { if (keepPage()) { renderList(); schedule(); } else window.location.reload(); });
  }
  /* Never reload while the form is open (its added screen after a cart move) or while the estimate has doors: a
     failed refresh (for example Shopify's rate limit) would close that screen, and a browser that keeps the estimate
     only in memory would lose it. The rows are drawn from the page instead. */
  function keepPage() {
    var L = EL();
    return !!((window.MadWizard && window.MadWizard.isOpen && window.MadWizard.isOpen()) || (L && L.count && L.count() > 0));
  }

  function productAndRow(el) {
    var row = el.closest(ROW), product = row ? productOf(row) : null;
    return { row: row, product: product, raw: row ? savedRaw(rawOf(row), product) : null, lineKey: row ? row.getAttribute('data-mad-line-key') : el.getAttribute('data-mad-line-key') };
  }

  /* "Price additional services" on a plain door line (Release B): the 40-line limit first (nothing opens when these
     doors would take the quote past it), then the full form in mode 'cart-move'. An antique joins the estimate once
     (none when it is already on it: the form then updates that entry). */
  function moveOpen(btn) {
    var q = productAndRow(btn), W = window.MadWizard, L = EL(), E = window.MADEstimate, row = q.row;
    var status = row && row.querySelector('[data-mad-move-status]');
    var say = function (text) { if (!status) return; status.textContent = text; status.hidden = !text; };
    var antique = (E && q.product && q.product.title ? E.detectDoorKind(q.product) : (row && row.getAttribute('data-mad-kind'))) === 'antique';
    var units = antique ? 1 : Math.max(1, parseInt(row && row.getAttribute('data-mad-quantity'), 10) || 1);
    var joining = L ? (antique && L.findByVariant && L.findByVariant(q.product && q.product.variantId) ? 0 : units) : 0;
    if (joining) { var total = quoteLineCount(joining); if (total > QUOTE_LINE_LIMIT) { say(tooManyText(total, joining)); return; } }
    if (!W || typeof W.open !== 'function' || !q.product) { say('The form did not load. Refresh the page and try again.'); return; }
    say('');
    W.open({ product: q.product, mode: 'cart-move', lineKey: q.lineKey, units: units, source: 'cart', opener: btn });
  }

  document.addEventListener('click', function (e) {
    var mv = e.target.closest('[data-mad-move-open]');
    if (mv) { e.preventDefault(); moveOpen(mv); return; }
    var edit = e.target.closest('[data-mad-edit]');
    if (edit) {
      var q = productAndRow(edit), W = window.MadWizard;
      if (W && typeof W.open === 'function') {
        e.preventDefault();
        /* Add details opens on the step that is still open, Edit on "Review your door" (openStep); Clarity hears
           wizard_open and wizard_open_edit */
        W.open({ product: q.product, mode: 'cart-edit', lineKey: q.lineKey, raw: q.raw, step: openStep(q.raw) || undefined, source: 'edit', opener: edit });
      }
      return; /* no MadWizard: the link goes to the product page with ?customize=1 */
    }
    var rm = e.target.closest('[data-mad-remove]');
    if (rm) {
      var qr = productAndRow(rm), W2 = window.MadWizard, L = EL();
      if (qr.row && qr.row.hasAttribute('data-mad-estimate-row') && L) { e.preventDefault(); L.remove(qr.lineKey); return; }
      if (W2 && typeof W2.removeLine === 'function') { e.preventDefault(); W2.removeLine(qr.lineKey).then(refreshSections, refreshSections); return; }
      var native = qr.row && qr.row.querySelector('cart-remove-button a');
      if (native) { e.preventDefault(); native.click(); }
    }
  });

  ['mad:wizard:updated', 'mad:wizard:added', 'mad:wizard:removed'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.detail && e.detail.estimateList) return; /* the list changed, not the cart: mad:estimate:changed re-renders */
      setTimeout(refreshSections, 150);
    });
  });
  document.addEventListener('mad:estimate:changed', function () { renderList(); schedule(); });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-mad-estimate-clear]')) return;
    e.preventDefault();
    var L = EL(); if (!L) return;
    if (window.confirm('Clear your estimate? This removes every door on it from this browser.')) L.clear();
  });

  /* Codex re-check (2026-09-26): the prepared Zap (version 2, zap/zap-code-v2.js SETTINGS.max_doors) rejects a quote
     request whose cart_json carries more than 40 lines, after the site has already said "sent" (the webhook answers
     200 before the Zap runs). So the site checks the count first: before doors move from the cart to the estimate and
     before a request is sent. Nothing is removed; the customer is told to send it in two parts or call. */
  var QUOTE_LINE_LIMIT = 40;
  /* How many lines the quote request would carry (quoteCart below): with the estimate list in use (or about to be,
     extraListLines doors joining it), the list's lines plus every cart line with saved choices; otherwise the cart. */
  function quoteLineCount(extraListLines) {
    var L = EL(), extra = Number(extraListLines) || 0, listLines = L ? L.count() + extra : 0;
    var cart = Array.prototype.slice.call(document.querySelectorAll(ROW)).map(lineOf).filter(function (l) { return !l.listRow; });
    if (!(listLines > 0)) return cart.length;
    return listLines + cart.filter(function (l) { return !!l.raw || l.hasRawAttr; }).length;
  }
  function phoneText() { return (window.MadQuoteConfig && window.MadQuoteConfig.phone) || config().phone || '(337) 273-0189'; }
  /* n: the lines the request would carry; moving: doors about to move to the estimate (Price additional services on a
     cart line), or 0 */
  function tooManyText(n, moving) {
    return 'One quote request can hold up to ' + QUOTE_LINE_LIMIT + ' doors, and ' + (moving ? 'moving ' + (moving > 1 ? 'these ' + moving : 'this door') + ' would make ' + n : 'this one has ' + n) + '. '
      + (moving ? 'Nothing was moved.' : 'Nothing was sent or removed.') + ' Please send your quote in two parts, or call ' + phoneText() + ' and we will quote them all.';
  }

  /* A cart line with saved choices as the quote sends it: normalized with the product its row on this page carries
     (R04), so the draft prices what the page shows. A line with no row here, or unchanged, goes as it is. */
  function sentItem(item) {
    var E = window.MADEstimate, book = window.MAD_PRICE_BOOK, props = item && item.properties;
    if (!props || !props._raw || !E || !book || !E.normalizeSavedLine) return item;
    var raw = plainObject(parseJSON(props._raw)), row = null;
    Array.prototype.forEach.call(document.querySelectorAll(ROW), function (r) { if (!row && !r.hasAttribute('data-mad-estimate-row') && r.getAttribute('data-mad-line-key') === String(item.key)) row = r; });
    if (!raw || !row) return item;
    var n = E.normalizeSavedLine(raw, props, productOf(row), book);
    return n.changed ? Object.assign({}, item, { properties: n.properties }) : item;
  }
  /* The quote the shared step sends, in the /cart.js shape the Zap reads: the estimate list (through
     its adapter) plus any older customized cart line; with no list, the cart itself, as before. */
  function quoteCart() {
    var L = EL();
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return { items: [], item_count: 0, total_price: 0 }; }).then(function (cart) {
      if (!(L && L.count() > 0)) return Object.assign({}, cart, { items: (cart.items || []).map(sentItem) });
      var q = L.toCart();
      var legacy = (cart.items || []).filter(function (i) { return i.properties && i.properties._raw; }).map(sentItem);
      q.items = q.items.concat(legacy);
      q.item_count = q.items.reduce(function (s, i) { return s + (Number(i.quantity) || 1); }, 0);
      q.total_price = q.items.reduce(function (s, i) { return s + (Number(i.final_line_price) || 0); }, 0);
      return q;
    });
  }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 60); }
  function observe() {
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) new MutationObserver(schedule).observe(el, { childList: true, subtree: true });
    });
  }

  window.MadQuoteLines = { collect: collect, refresh: refresh, refreshSections: refreshSections, summaryFor: summaryFor, lineOf: lineOf, money: money, quoteCart: quoteCart, renderList: renderList, listActive: listActive, rowHtml: rowHtml,
    QUOTE_LINE_LIMIT: QUOTE_LINE_LIMIT, quoteLineCount: quoteLineCount, tooManyText: tooManyText, frameOpen: frameOpen, pairOpen: pairOpen, openStep: openStep, openTopic: openTopic, moveOpen: moveOpen };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { observe(); refresh(); });
  else { observe(); refresh(); }
})();
